import type { ReactNode } from "react";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ApartmentOutlined,
  AccountBookOutlined,
  TeamOutlined,
  LineChartOutlined,
  ProjectOutlined,
  CloudOutlined,
  SettingOutlined,
} from "@ant-design/icons";
const { Title, Text } = Typography;

const enterpriseModules = [
  { title: "供应链管理模块", path: "/enterprise/supply-chain", icon: <ApartmentOutlined style={{ fontSize: 28, color: "#1890ff" }} />, description: "采购、仓储、物流与供应商协同" },
  { title: "财务管理模块", icon: <AccountBookOutlined style={{ fontSize: 28, color: "#52c41a" }} />, description: "核算、预算、资金与报表" },
  { title: "人力资源系统", icon: <TeamOutlined style={{ fontSize: 28, color: "#722ed1" }} />, description: "组织、考勤、薪酬与绩效" },
  { title: "数据分析与 AI 系统", icon: <LineChartOutlined style={{ fontSize: 28, color: "#fa8c16" }} />, description: "BI 报表、预测与智能分析" },
  { title: "项目管理系统", icon: <ProjectOutlined style={{ fontSize: 28, color: "#eb2f96" }} />, description: "项目计划、任务与进度管理" },
  { title: "协同办公系统", icon: <CloudOutlined style={{ fontSize: 28, color: "#13c2c2" }} />, description: "流程审批、文档与协作" },
  { title: "IT 运维与基础架构系统", icon: <SettingOutlined style={{ fontSize: 28, color: "#2f54eb" }} />, description: "监控、发布与基础设施" },
];

type ModuleItem = { title: string; path?: string; icon: ReactNode; description: string };

export default function EnterpriseDigital() {
  const navigate = useNavigate();
  return (
    <div>
      <Title level={3} className="tech-page-title" style={{ marginBottom: 28, fontSize: 22 }}>
        企业数字化
      </Title>
      <Row gutter={[20, 20]}>
        {enterpriseModules.map((m: ModuleItem) => (
          <Col xs={24} sm={12} md={8} lg={6} key={m.title}>
            <Card
              hoverable
              onClick={() => {
                if (m.path) navigate(m.path);
              }}
              className="tech-card"
              style={{ cursor: "pointer", height: "100%", borderRadius: 12 }}
              bodyStyle={{ padding: 24 }}
            >
              <div style={{ textAlign: "center", marginBottom: 16 }}>
                <span className="tech-icon-wrap">{m.icon}</span>
              </div>
              <Title level={5} style={{ marginBottom: 8, textAlign: "center", fontWeight: 600 }}>
                {m.title}
              </Title>
              <Text type="secondary" style={{ fontSize: 12, display: "block", textAlign: "center" }}>
                {m.description}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
